var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-sushi',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative pt-10"},[_c('hotspot-richmedia',{staticClass:"-top-2 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                "Colloque Sûreté de l'Ingénierie - 26 septembre 2014"
                            ),
                        }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-nandor',
                            to: 'to-nandor',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Content
                                    .text
                            )}}),_c('router-link',{attrs:{"to":{
                                name: 'catalogue',
                                params: { slug: 'page-015' },
                            }},domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Content_03.text
                            )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content
                                    .sParagraphThree_Content_02.text
                            )}})],1)],1)]),_c('div',{staticClass:"mb-4 lg:mb-8"},[_c('image-with-descriptions',{attrs:{"options":{
                        image:
                            'pages/' +
                            _vm.currentPage.slug +
                            '/' +
                            _vm.currentPage.images.oImage2.src,
                        descriptions: [
                            {
                                text: _vm.currentPage.images.oImage2.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: _vm.currentPage.images.oImage2.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            } ],
                    }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('div',{staticClass:"font-bold",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSubTitleOne
                                    .text
                            )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphContentOne
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('div',{staticClass:"break-inside-avoid"},[_c('span',{staticClass:"font-bold",domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .sParagraphSubTitleTwo.text
                                )}}),_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#81C341',
                                        '#B7DD92',
                                        '#cce5a4' ],
                                    direction: 'bottom',
                                }}}),_c('image-with-descriptions',{staticClass:"mb-4",attrs:{"options":{
                                    image:
                                        'pages/' +
                                        _vm.currentPage.slug +
                                        '/' +
                                        _vm.currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: _vm.currentPage.images.oImage3
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: _vm.currentPage.images.oImage3
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        } ],
                                }}})],1),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphContentTwo
                                    .text
                            )}})])],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }